export const getWhiteSpaces = (num = 0) => {
  const cal = Array(num)
    .fill(num)
    .map((__) => "\xa0")
    .join("");
  return cal;
};



// WEBPACK FOOTER //
// ./src/utils/getWhiteSpaces.js